import classNames from 'classnames';
import hoistNonReactStatics from 'hoist-non-react-statics';
import React from 'react';
import { ListItemGroup, ListItemSC, listClasses } from './list-item.styled';

type TListItem = React.ForwardRefExoticComponent<
  ListItemProps & React.RefAttributes<HTMLDivElement>
> & { Group: typeof ListItemGroup };

interface ListItemProps
  extends Omit<
    React.DetailedHTMLProps<React.HtmlHTMLAttributes<HTMLDivElement>, HTMLDivElement>,
    'ref'
  > {
  left?: React.ReactNode;
  right?: React.ReactNode;
  children: React.ReactNode;

  selected?: boolean;
  disabled?: boolean;
}

const ListItem = (props: ListItemProps, ref?: React.Ref<HTMLDivElement>) => {
  const { left, right, children, className, selected, disabled, ...rest } = props;

  return (
    <ListItemSC
      {...rest}
      ref={ref}
      className={classNames(listClasses.wrapper, className, {
        [`${listClasses.wrapper}-selected`]: selected,
        [`${listClasses.wrapper}-disabled`]: disabled,
        [`${listClasses.wrapper}-clickable`]: !!props.onClick,
      })}
    >
      {left ? left : null}
      <div
        className={classNames(listClasses.content, {
          [`${listClasses.content}-has-left`]: !!left,
          [`${listClasses.content}-has-right`]: !!right,
        })}
      >
        {children}
      </div>
      {right ? right : null}
    </ListItemSC>
  );
};

ListItem.Group = ListItemGroup;

export default hoistNonReactStatics(React.forwardRef(ListItem), ListItem) as TListItem;
